import { Route, Routes } from "react-router-dom";
import Login from "../../views/Login/Login";
import React, { Suspense } from "react";
import Main from "../../views/Main/Main";


const GuestRoutes = () => {
    return (
        <Routes>
            <Route path={`/`} element={<Main/>} />
            <Route path={'/:company'} element={<Suspense fallback={<>skeleton</>}>
                <Login/>
            </Suspense>}/>
        </Routes>
    )
}

export default GuestRoutes
